<template lang="html">
  <div>
    <v-dialog
      v-model="EditAlbumsDialog"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
    >
    <v-overlay :value="progress">
      <v-progress-circular
        indeterminate
        size="64"
      ></v-progress-circular>
    </v-overlay>
    <v-card :style="stylechat">
      <v-layout row wrap justify-center align-center class="mt-3 pl-3 pr-3">
        <v-col
          cols="2"
          justify="center"
          align="start"
          class="pl-2 pr-0 pt-0 pb-0"
          @click="close()"
        >
          <v-icon style="font-size: 30px !important;">mdi-close</v-icon>
        </v-col>
        <v-col
          cols="10"
          justify="center"
          align="end"
          class="pr-2 pl-0 pt-0 pb-0"
          >
          <b @click="editAlbums()" :class="EditAlbumsDetail.albums_name === name_edit || name_edit === '' || name_edit === null ? 'text-btn-disable' : 'text-btn'">{{$t('AnswerQuestion.keep')}}</b>
        </v-col>
      </v-layout>
      <v-divider class="mt-4 mb-2"></v-divider>
      <div class="pt-3 pl-5 pr-5 pb-2 list-overflow">
        <v-textarea
          v-model="name_edit"
          :placeholder="$t('Alert.Fail.Album.emptyName')"
          no-resize
          outlined
          rows="3"
          row-height="25"
          counter="50"
          maxlength="50"
          clearable
        ></v-textarea>
      </div>
    </v-card>
    <Warning :WarningDialog="WarningDialog" :WarningDialogDetail="WarningDialogDetail" @emitWarning="emitWarning" @closeAlertDialog="closeAlertDialog"/>
    <ErrorAlert :ErrorDialog="ErrorDialog" :ErrorDialogDetail="ErrorDialogDetail" @closeAlertDialog="closeAlertDialog"/>
    <!-- <ListBottomMenu :ListBottomMenu="ListBottomMenu" :ListBottomItem="ListBottomItem" @emitListBottom="emitListBottom" @closeAlertDialog="closeAlertDialog"/> -->

  </v-dialog>
</div>
</template>

<script>
import { Momenttime } from '@/services'
import Warning from '@/components/Alert/Warning'
import ErrorAlert from '@/components/Alert/Error'
import LinkPrevue from 'link-prevue'
import VuePdfEmbed from 'vue-pdf-embed/dist/vue2-pdf-embed'
import { vplayer, aplayer } from 'vue-hls-player'
// import ListBottomMenu from '@/components/Alert/ListBottomMenu'

var _ = require('lodash')
export default {
  props: {
    EditAlbumsDialog: Boolean,
    EditAlbumsDetail: {},
    AlbumsRoom: String
  },
  data () {
    return {
      name_edit: '',
      detail_modal: {},
      date_image: '',
      progress_btm: false,
      activeKey: '',
      activeTabName: '',
      tokenuser: '',
      tokenroom: '',
      data_user: {},
      publicPath: process.env.VUE_APP_BASE_PATH,
      DetailAlbumsDialog: false,
      NoteDetail: {},
      ListBottomMenu: false,
      ListBottomItem: [],
      ErrorDialog: false,
      ErrorDialogDetail: {},
      WarningDialog: false,
      WarningDialogDetail: {},
      list_image: [],
      list_file: [],
      list_link: [],
      status_edit: 'start',
      limit: 20,
      offset: 0,
      access_token: '',
      refresh_token: '',
      progress: false,
      nextgetMedia: true,
      thumbnail_video: '',
      muted_video: false,
      videoOptions: {
        autoplay: true,
        controls: true,
        muted: false,
        fullscreen: true,
      },
      pageCount: 1,
      page: null,
      numPages: 1,
      urlpdf: '',
      filenamepdf: '',
      sources_video: [],
      list_albums: [],
      offset: 0,
      stylechat: {
        "--EditAlbumsChat-HeaderColor": "white",
        "--EditAlbumsChat-TabBackground": "white",
        "--EditAlbumsChat-Icon": "gray",
        "--EditAlbumsChat-HeaderPictureBorderRadius": "6px",
        "--EditAlbumsChat-IconActive": "#2662ae",
        "--EditAlbumsChat-Background": "white",
        "--EditAlbumsChat-FontSize": "18px",
        "--EditAlbumsChat-FontSize-Title": "24px",
        "--EditAlbumsChat-FontColor": "back",
        "--EditAlbumsChat-FontSize-Status": "16px",
        "--EditAlbumsChat-FontColor-Status": "grey",
        "--EditAlbumsChat-Background-Input": "#E2E1E3",
        "--EditAlbumsChat-Color-Button": "#EFF2FE",
        "--EditAlbumsChat-FontColor-Button": "#2662ae",
        "--EditAlbumsChat-FontColor-Block-Button": "#cb1002",
        "--EditAlbumsChat-FontColor-Dis-Button": "#e2e1e3",
        "--EditAlbumsChat-Btn-Confirm-Background": "#2662ae",
        "--EditAlbumsChat-Btn-Confirm-Color": "white",
        "--EditAlbumsChat-Btn-Confirm-FontSize": "18px",
        "--EditAlbumsChat-Btn-Cancel-Background": "white",
        "--EditAlbumsChat-Btn-Cancel-Color": "#2662ae",
        "--EditAlbumsChat-Btn-Cancel-FontSize": "18px",
        "--EditAlbumsChat-Btn-Leave-Background": "white",
        "--EditAlbumsChat-Btn-Leave-Color": "#ff5252",
        "--EditAlbumsChat-Btn-Leave-FontSize": "18px",
        "--EditAlbumsChat-FontSize-Title-Edit": "20px"
      },
    }
  },
  components: {
    ErrorAlert,
    Warning,
    LinkPrevue,
    vplayer,
    aplayer,
    VuePdfEmbed,
    // ListBottomMenu,
    // CreatedNoteChat,
    // EditNoteChat,
    // DetailNoteChat
  },
  watch: {
    EditAlbumsDialog () {
      if (this.EditAlbumsDialog) {
        var user_profile = ''
        if (JSON.parse(this.$cookie.get('user-profile') == null)) {
          user_profile = JSON.parse(localStorage.getItem('user-profile'))
        } else {
          user_profile = JSON.parse(this.$cookie.get('user-profile'))
        }
        this.data_user = user_profile['account']['profile']
        this.tokenuser = this.data_user.tokenuser
        this.tokenroom = this.AlbumsRoom
        this.access_token = this.$cookie.get('access_token')
        this.refresh_token = this.$cookie.get('refresh_token')
        this.name_edit = this.EditAlbumsDetail.albums_name
        // console.log(this.EditAlbumsDetail)
      }
    },
  },
  created () {
    // var user_profile = JSON.parse(this.$cookie.get('user-profile-private'))
    // this.data_user = user_profile
    // this.tokenuser = this.data_user.business_user_id
  },
  methods: {
    editAlbums () {
      var body = {
        new_name: this.name_edit,
        albums_id: this.EditAlbumsDetail.album_id,
        tokenroom: this.tokenroom,
        tokenuser: this.tokenuser
      }
      this.axios.post(process.env.VUE_APP_API_EVENT + `/edit_albums_name`, body, {
      }).then((response) => {
        if (response.data.status == 'success') {
          this.$emit('emitComponents', {
            name: 'edit-album',
            value: false
          })
        }
      }).catch(err => {
        console.log(err.response)
        if (err.response.data.status === 401) {
          var data = {
            type: 'editAlbums',
            key: ''
          }
          // this.getNewAccess(this.access_token, this.refresh_token, data)
        } else {
          this.ErrorDialogDetail = {
            title: 'Error',
            text: this.$t('Alert.Fail.default.somethingWrong')
          }
          this.ErrorDialog = true
        }
      })
    },
    close () {
      this.$emit('closeComponents', {
        name: 'edit-album',
        value: false
      })
    },
    emitWarning (item) {
      // console.log(item)
      this.WarningDialog = false
      if (item.type === 'delete-album') {
        this.deleteAlbum(item.detail.id, item.index)
      }
    },
    closeComponents (data) {
      // console.log(data)
      if (data.name === 'create-note') {
        this.CreatedEditAlbumsDialog = data.value
      } else if (data.name === 'edit-note') {
        this.EditEditAlbumsDialog = data.value
      } else if (data.name === 'detail-note') {
        this.DetailEditAlbumsDialog = data.value
      }
    },
    closeAlertDialog (data) {
      // console.log(data)
      if (data.type === 'warning') {
        this.WarningDialog = data.value
      } else if (data.type === 'err') {
        this.ErrorDialog = data.value
      } else if (data.type === 'bottommenu') {
        this.ListBottomMenu = data.value
      }
    },
    getNewAccess (oldaccess, oldrefresh, data) {
      var body = {
        access_token: oldaccess,
        refresh_token: oldrefresh
      }
      this.axios.post(process.env.VUE_APP_API_PRIVATE + `/v1/renew-access-token`, body, {
      }).then((response) => {
        if (response.data.status === 200) {
          // console.log(response.data.data)
          this.access_token = response.data.data.access_token
          this.refresh_token = response.data.data.refresh_token
          this.$cookie.set('access_token', response.data.data.access_token)
          this.$cookie.set('refresh_token', response.data.data.refresh_token)
          if (data.type === 'editAlbums') {
            this.editAlbums()
          }
        }
      }).catch(err => {
        // console.log(err)
        console.log(err.response.data)
      })
    },
  }
}
</script>

<style lang="css" scoped>
.text-btn {
  color: var(--EditAlbumsChat-FontColor-Button) !important
}
.text-btn-disable {
  color: var(--EditAlbumsChat-FontColor-Dis-Button) !important
}
.color-white {
    color: white !important;
}
.fz-20 {
  font-size: 20px !important;
}
>>>.player__controls--progress {
  flex: 1 !important;
  margin: 0 8px !important;
  z-index: 0 !important;
}
>>>.aplayer .player__controls--durration {
  color: rgb(0 0 0) !important;
}
>>>.video-js {
  display: block;
  vertical-align: top;
  box-sizing: border-box;
  color: #fff;
  background-color: #000;
  position: relative;
  padding: 0;
  font-size: 10px;
  line-height: 1;
  font-weight: 400;
  font-style: normal;
  font-family: Arial,Helvetica,sans-serif;
  word-break: initial;
  /* height: 100% !important; */
  width: 100% !important;
}
.modalc {
    display: none;
    /* Hidden by default */
    position: fixed;
    /* Stay in place */
    z-index: 1;
    /* Sit on top */
    left: 0;
    top: 0;
    width: 100vw;
    /* Full width */
    height: 100vh;
    /* Full height */
    overflow: hidden;
    background-color: rgba(0, 0, 0, 0.9);
    /* Black w/ opacity */
}

.modal-contentc {
    padding-top: 10vh;
    margin: auto;
    display: block;
    max-width: 95%;
    max-height: 80%;
}

#headcaption {
    margin: auto;
    display: block;
    text-align: left;
    color: #fff;
    padding-top: 1vh;
    padding-bottom: 1vh;
    background-color: var(--EditAlbumsChat-HeaderPictureBorderRadius) !important;
}
.height-80vh {
  height: 80vh;
  overflow: hidden;
}
.col-no-media {
  border-style: solid;
  border-width: thin;
  border-radius: 15px;
  background-color: #8080801c;
  border-color: #8080801c;
  height: 100px;
  align-items: center;
  justify-content: center;
  display: flex;
  color: gray;
}
.text-overflow-link {
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  width: 60vw;
}
>>>.v-list-item .v-list-item__title {
  line-height: 2.0 !important;
}
.fz-19 {
  font-size: 19px;
}
.fw-600 {
  font-weight: 600;
}
.centerimg_website {
  justify-content: center;
  display: flex;
  margin-bottom: 10px;
}
.img_website {
  height: 50px;
  width: 50px;
  margin: auto;
  border-radius: 10px;
  object-fit: cover;
}
.layout-panels {
  height: calc(100vh - 140px) !important;
  /* height: 210px; */
  overflow-y: auto;
  /* background-color: bisque; */
  width: 100% !important;
}
.layout-panels::-webkit-scrollbar {
  width: 3px;
}

.layout-panels::-webkit-scrollbar-thumb {
  border-radius: 10px;
  background: rgba(0, 0, 0, .1);
}

>>>.ant-tabs-nav .ant-tabs-tab-active {
  color: var(--EditAlbumsChat-IconActive) !important;
  text-shadow: 0 0 0.25px currentColor !important;
}
>>>.ant-tabs-ink-bar {
  position: absolute;
  bottom: 1px;
  left: 0;
  z-index: 0;
  box-sizing: border-box;
  height: 2px;
  background-color: var(--EditAlbumsChat-IconActive) !important;
  transform-origin: 0 0;
}
.font-list-title {
  font-weight: 600;
  color: var(--EditAlbumsChat-FontColor) !important;
}
.width-100 {
  width: 100% !important;
}
.fz-30 {
  font-size: 30px !important;
}
.fz-50 {
  font-size: 50px !important;
}
.text-transform {
  text-transform: none;
}
.text-title {
  font-size: var(--EditAlbumsChat-FontSize-Title) !important;
  color: var(--EditAlbumsChat-FontColor) !important;
  font-weight: 600;
}
.text-title-edit {
  font-size: var(--EditAlbumsChat-FontSize-Title-Edit) !important;
  color: var(--EditAlbumsChat-FontColor) !important;
}
.tab-title {
  color: var(--EditAlbumsChat-FontColor) !important;
  font-size: var(--EditAlbumsChat-FontSize) !important;
  font-weight: 600;
}
.tab-title-status {
  color: var(--EditAlbumsChat-FontColor-Status) !important;
  font-size: var(--EditAlbumsChat-FontSize-Status) !important;
}
.text-overflow {
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  width: 50vw;
}
.text-overflow-modal {
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  width: 100%;
}
.checkbox-color {
  color: var(--EditAlbumsChat-IconActive) !important;
}
>>>.v-application .elevation-10 {
  box-shadow: none !important;
}
>>>.theme--light.v-sheet {
  box-shadow: none !important;
}
.list-overflow {
  height: calc(100vh - 64px) !important;
  overflow-y: scroll;
  /* background-color: bisque; */
  width: 100% !important;
}
.list-overflow::-webkit-scrollbar {
  width: 3px;
}

.list-overflow::-webkit-scrollbar-thumb {
  border-radius: 10px;
  background: rgba(0, 0, 0, .1);
}

.list-overflow-select {
  height: calc(100vh - 210px) !important;
  overflow-y: auto;
  /* background-color: bisque; */
  width: 100% !important;
}
.list-overflow-select::-webkit-scrollbar {
  width: 3px;
}

.list-overflow-select::-webkit-scrollbar-thumb {
  border-radius: 10px;
  background: rgba(0, 0, 0, .1);
}
/* >>>.v-input__slot {
  background-color: var(--EditAlbumsChat-Background-Input) !important;
  border-radius: 10px !important;
} */
>>>.v-text-field.v-text-field--solo:not(.v-text-field--solo-flat) > .v-input__control > .v-input__slot {
  box-shadow: none !important;
  background-color: var(--EditAlbumsChat-Background-Input) !important;
  border-radius: 10px !important;
}
>>>.v-dialog--fullscreen {
  border-radius: 0;
  margin: 0;
  height: 100%;
  position: fixed;
  /* overflow-y: auto; */
  top: 0;
  left: 0;
  overflow: hidden;
}
>>>.v-sheet.v-card:not(.v-sheet--outlined) {
  box-shadow: none !important;
}
.icon-color-edit {
  color: var(--EditAlbumsChat-Icon) !important;
}
.icon-color {
  color: var(--EditAlbumsChat-IconActive) !important;
}
.btn-confirm {
  background-color: var(--EditAlbumsChat-Btn-Confirm-Background) !important;
  color: var(--EditAlbumsChat-Btn-Confirm-Color) !important;
  font-size: var(--EditAlbumsChat-Btn-Confirm-FontSize) !important;
  font-weight: 600;
}
.btn-cancel {
  background-color: var(--EditAlbumsChat-Btn-Cancel-Background) !important;
  color: var(--EditAlbumsChat-Btn-Cancel-Color) !important;
  font-size: var(--EditAlbumsChat-Btn-Cancel-FontSize) !important;
  font-weight: 600;
}
.btn-leave {
  background-color: var(--EditAlbumsChat-Btn-Leave-Background) !important;
  color: var(--EditAlbumsChat-Btn-Leave-Color) !important;
  font-size: var(--EditAlbumsChat-Btn-Leave-FontSize) !important;
  font-weight: 600;
}
.img-position {
  object-fit: cover;
  object-position: 50% 0;
  border-style: solid;
  border-width: thin;
  border-color: #e8e8e8;
}
.layout-page {
  /* height: calc(100vh - 64px) !important; */
  height: 100vh !important;
  overflow: hidden !important;
  background-color: var(--EditAlbumsChat-Background) !important;
}

.text-transform {
  text-transform: none;
}
.text-title {
  font-size: var(--EditAlbumsChat-FontSize-Title) !important;
  color: var(--EditAlbumsChat-FontColor) !important;
  font-weight: 600;
}
.tab-title {
  color: var(--EditAlbumsChat-FontColor) !important;
  font-size: var(--EditAlbumsChat-FontSize) !important;
  font-weight: 600;
}
.tab-title-status {
  color: var(--EditAlbumsChat-FontColor-Status) !important;
  font-size: var(--EditAlbumsChat-FontSize-Status) !important;
}
/* .text-overflow {
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  width: 70vw;
} */
</style>
